import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This npm Orgs Payment Plan (this `}<em parentName="p">{`Payment Plan`}</em>{`) supplements
the terms for npm Open Source offered by npm, Inc. (`}<em parentName="p">{`npm`}</em>{`) at
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms"
      }}>{`https://docs.npmjs.com/policies/open-source-terms`}</a>{` (`}<em parentName="p">{`npm Open Source
Terms`}</em>{`), as well as the terms for npm Paid Services (`}<em parentName="p">{`npm Paid Services`}</em>{`)
at `}<a parentName="p" {...{
        "href": "/policies/private-terms"
      }}>{`https://docs.npmjs.com/policies/private-terms`}</a>{` (`}<em parentName="p">{`npm
Paid Services Terms`}</em>{`). This Payment Plan governs payment for
`}<em parentName="p">{`Orgs`}</em>{` and use of npm Paid Services by user
accounts added as members of those Orgs.`}</p>
    <p>{`This Payment Plan was last updated on
August 6, 2018.
You can review prior versions at
`}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/orgs-plan.mdx"
      }}>{`https://github.com/npm/documentation/blob/main/content/policies/orgs-plan.mdx`}</a>{`.`}</p>
    <p>{`Under this Payment Plan, you may create one or more Orgs.`}</p>
    <p>{`You will pay a minimum of $7.00 via your Payment Card when you create
an Org, and thereafter on the same day every month (your
`}<em parentName="p">{`Billing Day`}</em>{`), until you delete the Org. This minimum payment
entitles you to a single member of the Org (a `}<em parentName="p">{`New Paid Services
User`}</em>{`). You will pay $7.00 via your Payment Card per each additional
New Paid Services User that you add to an Org, counted and
billed on your Billing Day.`}</p>
    <p>{`Note that the npm Paid Services Terms require everyone using npm Paid
Services to have an Account of their own, added under a Payment Plan.
You must add a New Paid Services User to an Org for each
person who will use npm Paid Services under this Payment Plan.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      